export default __webpack_public_path__ + "CircularCustCapNum-BookItalic.ee5e6c1e2ef32cb396d88b936e2612eb.woff2";